const zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
  docked: 10,
  dropdown: 1000,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 2100,
  popover: 2000,
  skipLink: 1600,
  toast: 1700,
  tooltip: 2200,
}

/**
 * @deprecated
 * You can derive the ZIndices type from the DefaultChakraTheme
 *
 * type ZIndices = DefaultChakraTheme['zIndices']
 */
export type ZIndices = typeof zIndices

export default zIndices
